import {
    buildCompletedResultCacheKey,
    createCompletedResultCache,
} from './completedResultCache';

export const OPTIMIZER_SUMMARIES_CACHE_TTL_MS = 45_000;

const optimizerSummariesCache = createCompletedResultCache();

export function buildOptimizerSummariesCacheKey(userUid, watchlistVersion = 0) {
    return buildCompletedResultCacheKey([
        'optimizerSummaries',
        userUid,
        Number(watchlistVersion || 0),
    ]);
}

export function invalidateOptimizerSummariesCache(userUid) {
    if (userUid) {
        const prefix = buildCompletedResultCacheKey(['optimizerSummaries', userUid]);
        return optimizerSummariesCache.invalidate((key) => key.startsWith(`${prefix}|`));
    }
    return optimizerSummariesCache.invalidate((key) => key.startsWith('optimizerSummaries|'));
}

export function clearOptimizerSummariesCacheForTest() {
    optimizerSummariesCache.clear();
}

export function getOrLoadOptimizerSummaries({
    userUid,
    watchlistVersion = 0,
    loader,
    force = false,
    ttlMs = OPTIMIZER_SUMMARIES_CACHE_TTL_MS,
} = {}) {
    if (typeof loader !== 'function') {
        return Promise.resolve(undefined);
    }
    if (!userUid) {
        return Promise.resolve().then(() => loader());
    }

    const cacheKey = buildOptimizerSummariesCacheKey(userUid, watchlistVersion);
    if (force) {
        optimizerSummariesCache.invalidate(cacheKey);
    }

    return optimizerSummariesCache.getOrLoad(cacheKey, async () => {
        const result = await loader();
        if (result == null || typeof result !== 'object') {
            throw new Error('Optimizer summaries loader returned no response.');
        }
        return result;
    }, { ttlMs });
}
